// extracted by mini-css-extract-plugin
export default {"bg":"setup-account-page_bg__kLj60","card":"setup-account-page_card__SIAbg"};